export const DISCOUNT_SET = 'at/licenses/chooser/DISCOUNT_SET'
export const PRICE_SET = 'at/licenses/chooser/PRICE_SET'
export const PRICE_PER_TIME_INTERVAL_SET = 'at/licenses/chooser/PRICE_PER_TIME_INTERVAL_SET'
export const PURCHASE_PERIOD_SET = 'at/licenses/chooser/PURCHASE_PERIOD_SET'
export const START_DATE_SET = 'at/licenses/chooser/START_DATE_SET'
export const END_DATE_SET = 'at/licenses/chooser/END_DATE_SET'
export const USERS_COUNT_SET = 'at/licenses/chooser/USERS_COUNT_SET'
export const UNLIMITED_SET = 'at/licenses/chooser/UNLIMITED_SET'
export const PURCHASE_INFO_SET = 'at/licenses/chooser/PURCHASE_INFO_SET'


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/chooser/actionTypes.js